'use client';

import { createContext, useContext, type ReactNode } from 'react';

// WHY: null — сервер куку не читал (общий кэшированный HTML вики), вход известен только клиенту
type ServerAuth = boolean | null;

const ServerAuthContext = createContext<ServerAuth>(false);

interface ServerAuthProviderProps {
  hasAuthCookie: ServerAuth;
  children: ReactNode;
}

export function ServerAuthProvider({ hasAuthCookie, children }: ServerAuthProviderProps) {
  return (
    <ServerAuthContext.Provider value={hasAuthCookie}>{children}</ServerAuthContext.Provider>
  );
}

export function useServerHasAuth(): ServerAuth {
  return useContext(ServerAuthContext);
}
